import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import DocumentoProvider from "./DocumentoContext";
import PesquisarDocumento from "./Events/PesquisarDocumento";
import FormularioDocumento from "./Events/FormularioDocumento";

const Index = () => {
  let match = useRouteMatch();
  return (
    <DocumentoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarDocumento}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioDocumento}
          />
        </Switch>
      </div>
    </DocumentoProvider>
  );
};

export default Index;
